import type { OrderingDiagnostic } from 'modules/agreement/discountTree';

export type PolicyOrderingDiagnostic = OrderingDiagnostic<'Client' | 'Provider'>;

export function policyDiagnosticText(diagnostics: readonly PolicyOrderingDiagnostic[]) {
  return diagnostics.map(({ earlierRuleId, contexts }) => (
    <div key={earlierRuleId}>
      {`Earlier rule #${earlierRuleId} also supplies ${contexts.join(' and ')} auto factor policy.`}
    </div>
  ));
}
